import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Wheat, Trophy } from "lucide-react";

const CHOICES = [
    {
        to: "/projet/agricole",
        testid: "projet-agricole",
        overline: "Élevage & exploitation",
        title: "Projet agricole",
        icon: Wheat,
        img: "/images/cattle.jpg",
    },
    {
        to: "/projet/equestre",
        testid: "projet-equestre",
        overline: "Haras & équestre",
        title: "Projet équestre",
        icon: Trophy,
        img: "/images/equestrian1.jpg",
    },
];

const Panel = ({ choice, index }) => (
    <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.15 + index * 0.15 }}
        className="relative flex-1 overflow-hidden"
    >
        <Link
            to={choice.to}
            data-testid={choice.testid}
            className="group relative flex h-full w-full flex-col items-center justify-center px-6 text-center"
        >
            <img
                src={choice.img}
                alt={choice.title}
                className="absolute inset-0 h-full w-full object-cover transition-transform [transition-duration:1400ms] ease-out group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-rz-deep/65 transition-colors duration-500 group-hover:bg-rz-deep/45" />

            <div className="relative z-10 flex flex-col items-center">
                <span className="flex h-16 w-16 items-center justify-center rounded-full border border-white/30 bg-white/10 text-white backdrop-blur-sm transition-all duration-500 group-hover:scale-110 group-hover:bg-rz-sage group-hover:text-rz-deep">
                    <choice.icon size={28} />
                </span>
                <span className="mt-7 text-xs tracking-[0.25em] uppercase text-rz-pale">
                    {choice.overline}
                </span>
                <h2 className="font-display mt-3 text-[clamp(2rem,4vw,3.6rem)] font-extrabold tracking-tight text-white [text-shadow:_0_2px_24px_rgba(10,26,18,0.5)]">
                    {choice.title}
                </h2>
                <span className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-rz-green transition-all duration-300 group-hover:-translate-y-0.5 group-hover:shadow-xl group-hover:shadow-black/30">
                    Découvrir
                    <ArrowRight
                        size={17}
                        className="transition-transform duration-300 group-hover:translate-x-1"
                    />
                </span>
            </div>
        </Link>
    </motion.div>
);

export default function Projet() {
    return (
        <main
            data-testid="projet-page"
            className="relative flex h-[100svh] w-full flex-col overflow-hidden md:flex-row"
        >
            <div className="pointer-events-none absolute left-1/2 top-7 z-20 -translate-x-1/2 px-6 text-center">
                <p className="font-display text-sm md:text-base font-semibold tracking-[0.2em] uppercase text-white/0 md:text-white/90 [text-shadow:_0_2px_20px_rgba(10,26,18,0.6)]">
                    Quel est votre projet ?
                </p>
            </div>
            {CHOICES.map((choice, i) => (
                <Panel key={choice.to} choice={choice} index={i} />
            ))}
            <span className="pointer-events-none absolute left-1/2 top-[54%] z-20 hidden h-14 w-14 -translate-x-1/2 -translate-y-1/2 md:flex items-center justify-center rounded-full bg-white font-display text-sm font-bold text-rz-green shadow-xl">
                ou
            </span>
        </main>
    );
}
